import React, {useState} from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import Navigation from '../Navigation';
import LandingPage from '../Landing';
import SignInPage from '../SignIn';
import RegisterMultiFactorPage from '../RegisterMultiFactor';
import HomePage from '../Home';
import AccountPage from '../Account';
import AdminPage from '../Admin';
import DashboardPage from '../Dashboard';
import AlertsPage from '../Alerts';
import ProfilePage from '../Profile';
import CampaignsPage from '../Campaigns';
import AIAdvisorPage from '../AIAdvisor';
import AIKnowledgeBasePage from '../AIKnowledgeBase';
import Documentation from '../Documentation';
import CampaignDetailsPage from '../CampaignDetails';
import * as ROUTES from '../../constants/routes';
import {withAuthentication} from '../Session';
import {ThemeProvider} from 'theme-ui'
import theme from './theme'
import ReportsPage from "../Reports";

const App = () => {
        const [fakeUid, setFakeUid] = useState(null);
        return (<Router>
                <div>
                    <ThemeProvider theme={theme}>
                        <Navigation setFakeUid={setFakeUid}/>
                        <hr/>
                        <Route exact path={ROUTES.LANDING} component={LandingPage}/>
                        <Route exact path={ROUTES.SIGN_IN} component={SignInPage}/>
                        <Route exact path={ROUTES.REGISTER_MULTI_FACTOR} component={RegisterMultiFactorPage}/>
                        <Route exact path={ROUTES.HOME} component={HomePage}/>
                        <Route exact path={ROUTES.ACCOUNT} component={AccountPage}/>
                        <Route exact path={ROUTES.ADMIN} component={AdminPage}/>
                        <Route exact path={`${ROUTES.DASHBOARD}/:uid?`} component={() => <DashboardPage fakeUid={fakeUid}/>}/>
                        <Route exact path={`${ROUTES.CAMPAIGN_DETAILS}/:uid/:campaignId`} component={CampaignDetailsPage}/>
                        <Route exact path={ROUTES.ALERTS} component={() => <AlertsPage fakeUid={fakeUid}/>}/>
                        <Route exact path={ROUTES.CAMPAIGNS} component={CampaignsPage}/>
                        <Route exact path={ROUTES.REPORTS} component={() => <ReportsPage fakeUid={fakeUid}/>}/>
                        <Route exact path={ROUTES.PROFILE} component={() => <ProfilePage fakeUid={fakeUid}/>}/>
                        <Route exact path={ROUTES.AI_ADVISOR} component={() => <AIAdvisorPage fakeUid={fakeUid}/>}/>
                        <Route exact path={ROUTES.AI_KNOWLEDGE_BASE} component={() => <AIKnowledgeBasePage fakeUid={fakeUid}/>}/>
                        <Route path={`${ROUTES.DOCS}/:slug?`} component={Documentation}/>
                    </ThemeProvider>
                </div>
            </Router>
        )
    }
;

export default withAuthentication(App);